import type { PiiLookupDocumentDto } from "@babackapp/private-api-client/generated/schema";
import { Badge } from "@babackapp/ui/components/badge";

/**
 * Summary of a document's field comparisons, for a table row. The vault holds
 * each document's own values, so every field is expected to match.
 */
export function PiiStatusCell({
  document,
}: {
  document: PiiLookupDocumentDto;
}) {
  if (!document.isRecordedInVault) {
    return <Badge variant="outline">Pas dans le coffre</Badge>;
  }
  const gaps = document.comparisons.filter((c) => c.status !== "match").length;
  if (gaps > 0) {
    return (
      <Badge variant="outline" className="bg-red-100 text-red-800">
        {gaps} écart(s)
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="bg-green-100 text-green-800">
      OK
    </Badge>
  );
}
